import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../index';

export interface RoomProperty {
  id: string;
  name: string;
}

interface RoomPropertiesState {
  items: RoomProperty[];
  // Distinguishes "not fetched yet" from "fetched, and this location has none".
  // Consumers gate the patient form on it so it never seeds from an incomplete
  // lookup table. An empty payload still counts as loaded.
  loaded: boolean;
}

const initialState: RoomPropertiesState = {
  items: [],
  loaded: false
};

const roomPropertiesSlice = createSlice({
  name: 'roomProperties',
  initialState,
  reducers: {
    setRoomProperties: (state, action: PayloadAction<RoomProperty[]>) => {
      state.items = action.payload;
      state.loaded = true;
    },
    clearRoomProperties: (state) => {
      state.items = [];
      state.loaded = false;
    }
  }
});

export const { setRoomProperties, clearRoomProperties } = roomPropertiesSlice.actions;

export const selectRoomProperties = (state: RootState) => state.roomPropertiesSlice.items;

export const selectRoomPropertiesLoaded = (state: RootState) => state.roomPropertiesSlice.loaded;

export default roomPropertiesSlice.reducer;
